import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface NetworkErrorBannerProps {
  onRetry: () => void;
  isRetrying: boolean;
}

export const NetworkErrorBanner = ({ onRetry, isRetrying }: NetworkErrorBannerProps) => (
  <div className="flex items-center gap-3 rounded-md border border-destructive/50 bg-destructive/10 p-3 text-sm">
    <AlertTriangle className="h-4 w-4 shrink-0 text-destructive" />
    <div className="flex-1">
      <p className="font-medium text-destructive">Connection issue</p>
      <p className="text-muted-foreground text-xs">Unable to reach the server. Check your internet connection.</p>
    </div>
    <Button size="sm" variant="outline" onClick={onRetry} disabled={isRetrying}>
      {isRetrying ? "Retrying…" : "Retry"}
    </Button>
  </div>
);
